"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.taskTransition = exports.navTransition = exports.coverTransition = exports.sidePanelSwitchTransition = exports.panelSwitchTransition = exports.panelSwitchTransitionBack = exports.panelSwitchTransitionForward = exports.tabSwitchTransition = exports.tabSwitchTransitionBack = exports.tabSwitchTransitionForward = exports.assetTransition = exports.defaultTransition = exports.noTransition = void 0;
/**
 * Transition object compatible with CSSTransition.
 */
const styles = require("../scss/core/transitions.scss");
exports.noTransition = {
    appear: "",
    appearActive: "",
    enter: "",
    enterActive: "",
    exit: "",
    exitActive: ""
};
exports.defaultTransition = {
    appear: styles.defaultTransitionEnter,
    appearActive: styles.defaultTransitionEnterActive,
    enter: styles.defaultTransitionEnter,
    enterActive: styles.defaultTransitionEnterActive,
    exit: styles.defaultTransitionExit,
    exitActive: styles.defaultTransitionExitActive
};
exports.assetTransition = {
    appear: styles.assetTransitionEnter,
    appearActive: styles.assetTransitionEnterActive,
    enter: styles.assetTransitionEnter,
    enterActive: styles.assetTransitionEnterActive,
    exit: styles.assetTransitionExit,
    exitActive: styles.assetTransitionExitActive
};
exports.tabSwitchTransitionForward = {
    appear: styles.tabSwitchTransitionForwardEnter,
    appearActive: styles.tabSwitchTransitionForwardEnterActive,
    enter: styles.tabSwitchTransitionForwardEnter,
    enterActive: styles.tabSwitchTransitionForwardEnterActive,
    exit: styles.tabSwitchTransitionForwardExit,
    exitActive: styles.tabSwitchTransitionForwardExitActive
};
exports.tabSwitchTransitionBack = {
    appear: styles.tabSwitchTransitionBackEnter,
    appearActive: styles.tabSwitchTransitionBackEnterActive,
    enter: styles.tabSwitchTransitionBackEnter,
    enterActive: styles.tabSwitchTransitionBackEnterActive,
    exit: styles.tabSwitchTransitionBackExit,
    exitActive: styles.tabSwitchTransitionBackExitActive
};
exports.tabSwitchTransition = exports.tabSwitchTransitionForward;
exports.panelSwitchTransitionForward = {
    appear: styles.panelSwitchTransitionForwardEnter,
    appearActive: styles.panelSwitchTransitionForwardEnterActive,
    enter: styles.panelSwitchTransitionForwardEnter,
    enterActive: styles.panelSwitchTransitionForwardEnterActive,
    exit: styles.panelSwitchTransitionForwardExit,
    exitActive: styles.panelSwitchTransitionForwardExitActive
};
exports.panelSwitchTransitionBack = {
    appear: styles.panelSwitchTransitionBackEnter,
    appearActive: styles.panelSwitchTransitionBackEnterActive,
    enter: styles.panelSwitchTransitionBackEnter,
    enterActive: styles.panelSwitchTransitionBackEnterActive,
    exit: styles.panelSwitchTransitionBackExit,
    exitActive: styles.panelSwitchTransitionBackExitActive
};
exports.panelSwitchTransition = exports.panelSwitchTransitionForward;
exports.sidePanelSwitchTransition = {
    appear: styles.sidePanelSwitchTransitionEnter,
    appearActive: styles.sidePanelSwitchTransitionEnterActive,
    enter: styles.sidePanelSwitchTransitionEnter,
    enterActive: styles.sidePanelSwitchTransitionEnterActive,
    exit: styles.sidePanelSwitchTransitionExit,
    exitActive: styles.sidePanelSwitchTransitionExitActive
};
exports.coverTransition = {
    appear: styles.coverTransitionEnter,
    appearActive: styles.coverTransitionEnterActive,
    enter: styles.coverTransitionEnter,
    enterActive: styles.coverTransitionEnterActive,
    exit: styles.coverTransitionExit,
    exitActive: styles.coverTransitionExitActive
};
exports.navTransition = {
    appear: styles.navTransitionEnter,
    appearActive: styles.navTransitionEnterActive,
    enter: styles.navTransitionEnter,
    enterActive: styles.navTransitionEnterActive,
    exit: styles.navTransitionExit,
    exitActive: styles.navTransitionExitActive
};
exports.taskTransition = {
    appear: styles.taskTransitionEnter,
    appearActive: styles.taskTransitionEnterActive,
    enter: styles.taskTransitionEnter,
    enterActive: styles.taskTransitionEnterActive,
    exit: styles.taskTransitionExit,
    exitActive: styles.taskTransitionExitActive
};
//# sourceMappingURL=cssTransitions.js.map